export enum PHONE_NUMBER_FORMAT_STANDARDS {
  // E.164 is the international telephone numbering plan that
  // ensures each device on the PSTN has globally unique number.
  // https://www.twilio.com/docs/glossary/what-e164
  E164 = 'E.164',
  NATIONAL = 'NATIONAL',
}

export const COUNTRY_CODES = [
  { emoji: '🇨🇦', value: 'CA', country: 'Canada', countryCode: '+1' },
  { emoji: '🇩🇪', value: 'DE', country: 'Germany', countryCode: '+49' },
  { emoji: '🇬🇧', value: 'GB', country: 'United Kingdom', countryCode: '+44' },
  { emoji: '🇺🇸', value: 'US', country: 'United States', countryCode: '+1' },
];
